import Translation from "./Translation"

export default function Skills({ skills, toggleSkill, style }) {
    function skillsToDisplay() {
        let _skills = [];

        for(let i in skills) {
            if (skills[i].display === false) {
                continue;
            }

            _skills.push(skills[i])
        }

        return _skills;
    }

    function handleClick(e, skill) {
        if (toggleSkill(skill.name)){
            e.currentTarget.classList.remove("disabled")
        } else {
            e.currentTarget.classList.add("disabled")
        }
    }

    return (
        <div className="skills w-100" style={style.skills} >
            <div className="legend">{ Translation("Stack Technique") }</div>
            <div className="wrapper">
                {
                    skillsToDisplay().map((skill) => {
                        return (
                            <span 
                                key={skill.name} 
                                alt={skill.name} 
                                onClick={(e) => handleClick(e, skill)}
                                className={skill.enabled === false ? "disabled" : ""}
                            >
                                <i>{skill.name}</i>
                            </span>
                        )
                    })
                }
            </div>
        </div>
    )
}